export const GET_PATIENTS_REQUEST = "PATIENTS/GET_PATIENTS_REQUEST";
export const GET_PATIENTS_SUCCESS = "PATIENTS/GET_PATIENTS_SUCCESS";
export const GET_PATIENTS_FAILURE = "PATIENTS/GET_PATIENTS_FAILURE";

export const ADD_PATIENT_REQUEST = "PATIENTS/ADD_PATIENT_REQUEST";
export const ADD_PATIENT_SUCCESS = "PATIENTS/ADD_PATIENT_SUCCESS";
export const ADD_PATIENT_FAILURE = "PATIENTS/ADD_PATIENT_FAILURE";

export const DELETE_PATIENT_REQUEST = "PATIENTS/DELETE_PATIENT_REQUEST";
export const DELETE_PATIENT_SUCCESS = "PATIENTS/DELETE_PATIENT_SUCCESS";
export const DELETE_PATIENT_FAILURE = "PATIENTS/DELETE_PATIENT_FAILURE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Patients/constants.js